import { computed, ComputedRef, getCurrentInstance, ref } from 'vue';
import { useGlobalSearchStore } from '../../stores';
import { types } from '../../store/types/types.js';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router/composables';
import { docTypes } from '../../../shared/enums/docTypes';

export const useSearchExecution = () => {
  const router = useRouter();
  const route = useRoute();
  const globalSearchStore = useGlobalSearchStore();
  const { proxy } = getCurrentInstance();

  const { query, searchedQuery, results, filters, mediaResults, totalCount, hasMore, isLoading } = storeToRefs(
    useGlobalSearchStore()
  );

  const error = ref<unknown>(null);

  const institutionProfileIds: ComputedRef<number[]> = computed(
    () => proxy.$store.getters[types.GET_ACTIVE_INSTITUTIONS_PROFILES]
  );

  const activeChildrenInstitutionProfileIds: ComputedRef<number[]> = computed(
    () => proxy.$store.getters[types.GET_ACTIVE_CHILDREN]
  );

  const activeGroupId: ComputedRef<number> = computed(() => proxy.$store.getters[types.GET_ACTIVE_GROUP]?.id || null);

  const initializeSearch = async () => {
    await globalSearchStore.initializeSearch({
      institutionProfileIds: institutionProfileIds.value,
      activeChildrenInstitutionProfileIds: activeChildrenInstitutionProfileIds.value,
      groupId: activeGroupId.value,
    });
    if (totalCount.value === 0) {
      await runBackupSearch();
    }
  };

  const runBackupSearch = async () => {
    const fallbackDocType = filters.value.find(filter => filter.count > 0)?.key as docTypes;
    const fallbackRoles = [];
    if (fallbackDocType) {
      globalSearchStore.setDocType(fallbackDocType);
      globalSearchStore.setRoles(fallbackRoles);
      await globalSearchStore.initializeSearch({
        institutionProfileIds: institutionProfileIds.value,
        activeChildrenInstitutionProfileIds: activeChildrenInstitutionProfileIds.value,
        groupId: activeGroupId.value,
      });
      await router.push({ query: { ...route.query, filter: fallbackDocType } });
    }
  };

  const searchMore = async () => {
    await globalSearchStore.searchMore({
      institutionProfileIds: institutionProfileIds.value,
      activeChildrenInstitutionProfileIds: activeChildrenInstitutionProfileIds.value,
      groupId: activeGroupId.value,
    });
  };

  const reset = () => {
    globalSearchStore.reset();
  };

  return {
    query,
    searchedQuery,
    isLoading,
    results,
    mediaResults,
    totalCount,
    hasMore,
    error,
    initializeSearch,
    searchMore,
    reset,
  };
};
